/* eslint-disable react/no-array-index-key */
import React, { ChangeEvent } from 'react';
import { RadioButton } from '@gumtree/ui-library';

import { FilterItemWithState } from '../../util';
import Label from './label';
import { RadioButtonStyle } from './radio-button-list.style';

export const getLabels = (item: FilterItemWithState) => {
    const content = <Label label={item.label} abundance={item.abundance} />;

    const shouldShowSeoLink = item.abundance >= 5;

    if (shouldShowSeoLink) {
        return {
            label: '',
            labelLinkText: content,
            labelLink: item.uri,
        };
    } else {
        return {
            label: content,
            labelLinkText: undefined,
            labelLink: undefined,
        };
    }
};

const FilterRadioButtonList = ({
    filterItemsProcessed,
    filterKey,
    onLabelLinkClick,
}: {
    filterItemsProcessed: FilterItemWithState[];
    filterKey: string;
    onLabelLinkClick: (item: FilterItemWithState) => (event: ChangeEvent<HTMLInputElement>) => void;
}) => {
    return (
        <>
            {filterItemsProcessed.map((item, key) => {
                const { label, labelLinkText, labelLink } = getLabels(item);
                return (
                    <RadioButton
                        css={RadioButtonStyle(item.isVisible)}
                        id={`${filterKey}-${key}`}
                        key={`${filterKey}-${key}`}
                        name={filterKey}
                        label={label}
                        labelLinkText={labelLinkText}
                        labelLink={labelLink}
                        isNewTab={false}
                        value={item.value}
                        isChecked={Boolean(item.isChecked)}
                        onLabelLinkClick={onLabelLinkClick(item)}
                    />
                );
            })}
        </>
    );
};

export default FilterRadioButtonList;
